module.exports = __webpack_public_path__ + "static/media/success-check.7a74e91f.svg";